import { makeAutoObservable } from "mobx";

import { Day } from "./Day";
import MealPlanFormStore from "./MealPlanFormStore";

export default class DayColumns {
  durationDays = 0;
  startDate = new Date();

  // Store already created DayColumn instances here so that there's only one
  // DayColumn instance lying around for each index.
  private instances: Map<number, Day> = new Map();
  private store: MealPlanFormStore;

  private get array() {
    const arr = [];
    for (let index = 0; index < this.durationDays; index++) {
      arr.push(this.at(index));
    }
    return arr;
  }

  constructor(store: MealPlanFormStore) {
    makeAutoObservable(this);
    this.store = store;
  }

  setDuration(durationDays: number, startDate = new Date()): void {
    this.durationDays = durationDays;
    this.startDate = startDate;
  }

  at(index: number): Day {
    if (!this.instances.has(index)) {
      this.instances.set(index, new Day(this.store, index));
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.instances.get(index)!;
  }

  map<T>(fn: (day: Day) => T): T[] {
    return this.array.map(fn);
  }

  flatMap<T>(fn: (day: Day) => T | T[]): T[] {
    return this.array.flatMap(fn);
  }

  previous(day: Day): Day {
    return this.at(Math.max(day.index - 1, 0));
  }

  next(day: Day): Day {
    return this.at(Math.min(day.index + 1, this.durationDays - 1));
  }
}
